// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hwG7yM1rIlo8SlksPbKf{flex-direction:column;height:100%;display:flex}.ZfUTeBUXQosPfjCt60u7{margin:0 7px;padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hwG7yM1rIlo8SlksPbKf`,
	"tabs": `ZfUTeBUXQosPfjCt60u7`
};
export default ___CSS_LOADER_EXPORT___;
